var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "sh": "Company",
            "tabActive": "History",
            "bg": "/images/sub/visual/sv-company.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('sub-section', {
    staticClass: "page-section--first page-section--last"
  }, [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h3', {
    staticClass: "tit tit--lg"
  }, [_vm._v("History")])]), _c('div', {
    staticClass: "history-items"
  }, [_c('v-row', {
    staticClass: "history-item"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h4', {
    staticClass: "history-item__year"
  }, [_vm._v("2024")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-right"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("Undetermined")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("Planned office relocation")])], 1)], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "history-item"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h4', {
    staticClass: "history-item__year"
  }, [_vm._v("2023")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-right"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("11.01")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("Establishing Yoojin as a subsidiary")])], 1)], 1)], 1), _c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("07.15")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v(" Purchased corporation building "), _c('br'), _vm._v(" [Location : 8, Neungdong-ro 50-gil, Gwangjin-gu (Woosung Bldg)] ")])], 1)], 1)], 1), _c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("02.24")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("Establishing Youth Trading as a subsidiary")])], 1)], 1)], 1), _c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("01.30")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("GLOBAL RECYCLED STANDARD(GRS)")])], 1), _c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("ORGANIC COTTON STANDARD(OCS)")])], 1), _c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("BETTER COTTON INITIATIVE(BCI)")])], 1), _c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("Eco-friendly certification registration")])], 1)], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "history-item"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h4', {
    staticClass: "history-item__year"
  }, [_vm._v("2022")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-right"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("06.01")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("Converted to company-affiliated research institute")])], 1), _c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("Opened corporation website")])], 1), _c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("Founded new corporation (Location : Gwangjin-gu, Seoul)")])], 1)], 1)], 1), _c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("01.01")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("Managed corporation. Established ERP system for production")])], 1)], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "history-item"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h4', {
    staticClass: "history-item__year"
  }, [_vm._v("2021")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-left"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("12.31")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("Accomplished 200% sales")])], 1)], 1)], 1), _c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("10.28")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("Designated as IBK BEST PARTNER - Certified as business with outstanding export")])], 1)], 1)], 1), _c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("10.14")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("Signed MOU with Consortium for HRD Ability Magnified Program on manpower training project")])], 1), _c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("Seoul Human Resources Development Institute, Korea Chamber of Commerce and Industry")])], 1)], 1)], 1), _c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("06.01")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("Established a division for affiliates")])], 1)], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "history-item"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h4', {
    staticClass: "history-item__year"
  }, [_vm._v("2020")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-right"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("09.01")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("Purchased corporation building [Location : 344, Neungdong-ro, Gwangjin-gu (Dongjin Bldg)]")])], 1)], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "history-item"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h4', {
    staticClass: "history-item__year"
  }, [_vm._v("2018")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-left"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("12.05")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("Joined Korea International Trade Association")])], 1)], 1)], 1), _c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("11.22")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("Changed overseas corporation name "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("SHAOTEXTILE CO., LTD.")])], 1)], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "history-item"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h4', {
    staticClass: "history-item__year"
  }, [_vm._v("2015")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-right"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("03.10")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("Founded overseas corporation "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("SHAOTEX CO., LIMITED")])], 1)], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "history-item"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h4', {
    staticClass: "history-item__year"
  }, [_vm._v("2014")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-left"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("07.01")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("Changed corporate name "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("Unitex Corp. → Meitextile Co.,Ltd.")])], 1)], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "history-item"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h4', {
    staticClass: "history-item__year"
  }, [_vm._v("2010")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-right"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("00.00")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("Founded Unitex Corp.")])], 1)], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "history-item"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('h4', {
    staticClass: "history-item__year"
  }, [_vm._v("2000")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "6",
      "data-aos": "fade-left"
    }
  }, [_c('v-row', {
    staticClass: "row--small"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('div', {
    staticClass: "w-50px"
  }, [_c('strong', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_vm._v("00.00")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": ""
    }
  }, [_c('v-row', {
    staticClass: "row--small page-text"
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_vm._v("·")]), _c('v-col', [_vm._v("Founded Uniworth Corp.")])], 1)], 1)], 1)], 1)], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }